import { DraftContext } from "./DraftContext";
import { useReducer } from "react";
import { draftReducer, initialStateDraft } from "./DraftReducer";
import PropTypes from "prop-types";

// Crear el contexto
export const DraftProvider = ({ children }) => {
  // const [fieldColorsState, fieldColorsDispatch] = useReducer(fieldColorsReducer, initialStateFieldColors);
  const [draftState, draftDispatch] = useReducer(draftReducer, initialStateDraft); // Reducer con estado inicial

  return (
    <DraftContext.Provider
      value={{
        draftState,
        draftDispatch,
      }}
    >
      {children}
    </DraftContext.Provider>
  );
};

DraftProvider.propTypes = {
  children: PropTypes.node.isRequired,
};